<template>
  <v-breadcrumbs :items="items" class="px-0 py-0 mb-4">
    <template v-slot:divider>
      <v-icon small>mdi-chevron-right</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
        <span class="breadcrumb-text">{{ item.text }}</span>
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  props: {
    items: Array
  }
}
</script>

<style scoped>
.breadcrumb-text {
  font-size: 0.8125rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
}
</style>
